import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import * as React from 'react';

import { WidgetSettings } from '../../../../../../userSettings';

import { useManageDeleteAndVisibility } from './useManageDeleteAndVisibility';

export interface Props {
  settings: WidgetSettings;
}

export const ManageDeleteAndAndVisibility: React.FC<Props> = ({ settings }) => {
  const { handleDeleteWidget } = useManageDeleteAndVisibility(settings);
  return (
    <IconButton size="small" onClick={handleDeleteWidget} color="default">
      <DeleteIcon fontSize="large" />
    </IconButton>
  );
};
